Groupon = window.Groupon || {}
Groupon.Analytics = {

  MEMBERSHIP_GOAL_PREFIX: "new_membership",
  UNDEFINED_LABEL: "undefined",

  Trackers: {},

  initialize: function() {
    _.each(this.Trackers, function(tracker) {
      tracker.initialize();
    });
  },

  trackLoad: function(category, action, label) {
    this.trackEvent('trackLoad', [category, action, label]);
  },

  trackClick: function(category, action, label) {
    this.trackEvent('trackClick', [category, action, label]);
  },

  trackPageView: function(path) {
    _.each(this.Trackers, function(tracker) {
      tracker.trackPageView(path);
    });
  },

  trackEvent: function(eventType, params, optional) {
    var category = this.UNDEFINED_LABEL,
        action   = this.UNDEFINED_LABEL,
        label    = this.UNDEFINED_LABEL;

    if (typeof params === 'string') {
      category = params;

      if (params.match(this.MEMBERSHIP_GOAL_PREFIX)) {
        category = this.MEMBERSHIP_GOAL_PREFIX;
        action = params.replace(this.MEMBERSHIP_GOAL_PREFIX,'');
      }
    } else {
      category = params[0];
      action = params[1];
      label = params[2];
    }

    var opts = {
      type:     eventType,
      category: category,
      action:   action,
      label:    label
    };

    opts = _.extend(opts, optional);

    _.each(this.Trackers, function(tracker) {
      tracker.trackEvent(opts);
    });
  }
};


Groupon.Analytics.Logger = {

  debug: false,

  initialize: function() {
    if (typeof console !== "undefined") {
      this.logger = console;
    } else {
      this.logger = undefined;
    }
  },

  trackPageView: function(path) {
    if (this.debug && this.logger) {
      this.logger.log("trackPageView", path);
    }
  },

  trackEvent: function(opts) {
    if (this.debug && this.logger) {
      this.logger.log("trackEvent", opts);
    }
  }
};


Groupon.Analytics.Google = {

  DEFAULT_PROFILE_ID: 'UA-1250257-1',

  VISITOR_SCOPE : 1,
  SESSION_SCOPE : 2,
  PAGE_SCOPE    : 3,

  LAYER_TO_SLOT_MAP: {
    'deal-page-081811' : 1,
    'places-080311' : 2,
    'getaways-deal-081811' : 4,
    'checkout-page-081811' : 5,
    'smart-app-banner-ipad': 2
  },

  DEFAULT_DIVISION_SLOT   : 3,

  initialize: function() {
    var accountId;
    if (Groupon.Attributes) {
      accountId = Groupon.Attributes.google_analytics_profile_id;
    }
    accountId = accountId || this.DEFAULT_PROFILE_ID;

    _gaq = window._gaq || [];
    _gaq.push(['_setAccount', accountId]);
    _gaq.push(['_setDomainName', '.groupon.com']);

    this.loadExternalLibrary();

    if(window.google_division_changed) {
      this.setDivisionCustomVar(window.google_division_changed);
    }
    this._trackGoal();
  },

  loadExternalLibrary: function() {
    var ga = document.createElement('script');
    ga.type = 'text/javascript';
    ga.async = true;
    var protocol = 'https:' === document.location.protocol ? 'https://ssl' : 'http://www';
    ga.src = protocol + '.google-analytics.com/ga.js';
    var s = document.getElementsByTagName('script')[0];
    s.parentNode.insertBefore(ga, s);
  },

  trackPageView: function(path) {
    _gaq.push(['_trackPageview', path]);
  },

  trackEvent: function(opts) {
    _gaq.push(['_trackEvent', opts.category, opts.action, opts.label]);
  },

  setExperimentCustomVar: function(layerId, experimentId, variantId) {
    var slotId   = this._slotForExperimentLayer(layerId);
    layerId      = this._scrubWhitespace(layerId);
    experimentId = this._scrubWhitespace(experimentId);
    variantId    = this._scrubWhitespace(variantId);

    var name = "Exp-" + layerId;
    var safeExperimentId = experimentId + "/" + variantId;
    this.setCustomVar(name, safeExperimentId, slotId, this.VISITOR_SCOPE);
  },

  setDivisionCustomVar: function(newDivision) {
    this.setCustomVar("Division", newDivision, this.DEFAULT_DIVISION_SLOT, this.SESSION_SCOPE);
  },

  setCustomVar: function(label, value, slot, scope) {
    _gaq.push(['_setCustomVar', slot, label, value, scope]);
  },

  _scrubWhitespace: function(val) {
    return val.replace(/[\s]/g, '').replace(/[^\w]/g, '-');
  },

  _slotForExperimentLayer: function(layerId) {
    if(this.LAYER_TO_SLOT_MAP[layerId] == null) { return; }
    return this.LAYER_TO_SLOT_MAP[layerId];
  },

  _trackGoal: function() {
    if(window.google_goal){
      _gaq.push(
        ['_trackPageview', google_goal],
        // Order ID (Membership ID), Affiliation, Amount, Tax, Shipping, City, State, Country
        ['_addTrans', google_order_id, "", google_amount, "", "", "", "", ""],
        // Order ID (Membership ID), SKU, Product Name, Category, (Unit) Price, Quantity
        ['_addItem', google_order_id, google_sku, google_product_name, "Uncategorized", google_unit_price, google_quantity],
        ['_trackTrans']
      );
    } else {
      _gaq.push(['_trackPageview']);
    }
  }
};

Groupon.Analytics.PixelTracker = {

  PIXEL_URL: "/analytic/view.gif",

  TRACKING_COOKIE: 'pixel_tracking',

  initialize: function() {
    // noop
  },

  trackPageView: function(path) {
    if(typeof(path) === 'string'){
      path = {'path':path};
    }
    this.injectTrackingPixel('trackPageView', path);
  },

  trackEvent: function(opts) {
    this.injectTrackingPixel('trackEvent', opts);
  },

  injectTrackingPixel: function(type, options) {
    options = options || {};
    if(options.runOnLoad) {
      delete options.runOnLoad;
      this.stashTrackingPixel(type, options);
    } else {
      $('body').append($("<img />", {
        'src': this.__trackingPixelSource(type, options),
        'class': 'tracking-pixel',
        'height': 1,
        'width': 1
      }));
    }
  },

  stashTrackingPixel: function(type, options) {
    var cookie = $.parseJSON(Cookie.get(this.TRACKING_COOKIE)) || [];
    cookie.push(this.__trackingPixelParams(type, options));
    Cookie.set(this.TRACKING_COOKIE, $.toJSON(cookie));
  },

  injectTrackingPixelFromCookie: function() {
    _($.parseJSON(Cookie.get(this.TRACKING_COOKIE))).each(_(function(data, i) {
      var type = data.t;
      delete data.t;
      this.injectTrackingPixel(type, data);
    }).bind(this));
    Cookie.unset(this.TRACKING_COOKIE);
  },

  __trackingPixelSource: function(type, options) {
    return this.PIXEL_URL + '?' + $.param(this.__trackingPixelParams(type, options));
  },

  __trackingPixelParams: function(type, options) {
    _(options).extend({
      t: type,
      cb: this.__cacheBuster()
    });
    return options;
  },

  __cacheBuster: function() {
    return (new Date()).getTime();
  }
};

Groupon.Analytics.Trackers = [Groupon.Analytics.Google, Groupon.Analytics.Logger, Groupon.Analytics.PixelTracker];
Groupon.Analytics.initialize();